import { render, staticRenderFns } from "./exchangeRateHistory.vue?vue&type=template&id=87236260"
import script from "./exchangeRateHistory.vue?vue&type=script&lang=js"
export * from "./exchangeRateHistory.vue?vue&type=script&lang=js"
import style0 from "./exchangeRateHistory.vue?vue&type=style&index=0&id=87236260&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports